import { render, staticRenderFns } from "./ExamBatchMsgApplyRecord.vue?vue&type=template&id=f271f1d0&scoped=true"
import script from "./ExamBatchMsgApplyRecord.vue?vue&type=script&lang=js"
export * from "./ExamBatchMsgApplyRecord.vue?vue&type=script&lang=js"
import style0 from "./ExamBatchMsgApplyRecord.vue?vue&type=style&index=0&id=f271f1d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f271f1d0",
  null
  
)

export default component.exports